import React, { useState, useEffect } from "react";
import axios from "axios";
import { Box } from "@mui/material";
import { DataGridPremium, GridToolbar } from "@mui/x-data-grid-premium";

const ConsolidatedCampaignGroupReport = ({ startDate, endDate, token }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/reports/CallCentreSalesReports/ConsolidatedCampaignLeads?startDate=${startDate}&endDate=${endDate}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        // Transform the data to include id field required by DataGrid
        const transformedData = response.data.data.map((item, index) => ({
          ...item,
          id: index + 1,
        }));

        setData(transformedData);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (startDate && endDate) {
      fetchData();
    }
  }, [startDate, endDate, token]);

  const columns = [
    {
      field: "campaign_group",
      headerName: "Campaign Group",
      flex: 2,
    },
    {
      field: "target_leads",
      headerName: "Target Leads",
      flex: 1,
      type: "number",
    },
    {
      field: "actual_leads",
      headerName: "Actual Leads",
      flex: 1,
      type: "number",
    },
    {
      field: "leads_loaded",
      headerName: "Leads Loaded",
      flex: 1,
      type: "number",
    },
    {
      field: "leads_attempted",
      headerName: "Leads Attempted",
      flex: 1,
      type: "number",
    },
    {
      field: "contacts",
      headerName: "Contacts",
      flex: 1,
      type: "number",
    },
    {
      field: "touches",
      headerName: "Touches",
      flex: 1,
      type: "number",
    },
    {
      field: "calls_per_hour",
      headerName: "Calls/Hour",
      flex: 1,
      type: "number",
    },
    {
      field: "actual_leads_perc",
      headerName: "Actual Leads %",
      flex: 1,
      type: "number",
      valueFormatter: (params) => `${(params.value * 100).toFixed(1)}%`,
    },
    {
      field: "loaded_leads_perc",
      headerName: "Loaded Leads %",
      flex: 1,
      type: "number",
      valueFormatter: (params) => `${(params.value * 100).toFixed(1)}%`,
    },
    {
      field: "attempt_perc",
      headerName: "Attempt %",
      flex: 1,
      type: "number",
      valueFormatter: (params) => `${(params.value * 100).toFixed(1)}%`,
    },
    {
      field: "contact_perc",
      headerName: "Contact %",
      flex: 1,
      type: "number",
      valueFormatter: (params) => `${(params.value * 100).toFixed(1)}%`,
    },
  ];

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!data || data.length === 0) return <h3>No Data Available</h3>;

  return (
    <Box sx={{ height: 600, width: "100%", marginTop: 2 }}>
      <DataGridPremium
        rows={data}
        columns={columns}
        slots={{ toolbar: GridToolbar }}
        disableRowSelectionOnClick
        hideFooterPagination
        hideFooter
        sx={{
          "& .MuiDataGrid-row:nth-of-type(odd)": {
            backgroundColor: (theme) =>
              theme.palette.mode === "dark"
                ? theme.palette.grey[900]
                : theme.palette.grey[100],
          },
        }}
      />
    </Box>
  );
};

export default ConsolidatedCampaignGroupReport;
